import { Postmate } from './postmate';
export default Postmate;